module.exports = __webpack_public_path__ + "ipetbooking-build/img/logo-default_ding.5d2202a1.svg";